import axios from 'axios';

/** Shown when the user filtered to unanswered exercises but has none left in the selected scope. */
export const ALL_EXERCISES_RESOLVED_IN_SCOPE_MESSAGE =
  'Rozwiązałeś już wszystkie zadania z tego zakresu. Zmień ustawienia filtrowania, aby użyć już rozwiązanych zadań.';

const LEGACY_NO_EXERCISES_MATCHING_FILTERS = /brak zada[nń] spełniaj[aą]cych filtry/i;

const mapQueueUserMessage = (message: string): string => {
  if (LEGACY_NO_EXERCISES_MATCHING_FILTERS.test(message.trim())) {
    return ALL_EXERCISES_RESOLVED_IN_SCOPE_MESSAGE;
  }
  return message;
};

/** Pulls a user-readable message from DRF-style error payloads or falls back to a generic copy. */
export const resolveQueueErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as unknown;

    if (typeof data === 'string' && data.trim().length > 0) {
      return mapQueueUserMessage(data);
    }

    if (data && typeof data === 'object') {
      const record = data as Record<string, unknown>;
      const detail = record.detail ?? record.message;
      if (typeof detail === 'string' && detail.trim().length > 0) {
        return mapQueueUserMessage(detail);
      }

      const firstFieldError = Object.values(record).find(
        value =>
          (typeof value === 'string' && value.trim().length > 0) ||
          (Array.isArray(value) && value.some(entry => typeof entry === 'string' && entry.trim().length > 0)),
      );

      if (typeof firstFieldError === 'string') {
        return mapQueueUserMessage(firstFieldError);
      }
      if (Array.isArray(firstFieldError)) {
        const firstString = firstFieldError.find((entry): entry is string => typeof entry === 'string' && entry.trim().length > 0);
        if (firstString) {
          return mapQueueUserMessage(firstString);
        }
      }
    }

    if (!error.response) {
      return 'Nie udało się połączyć z serwerem. Sprawdź połączenie i spróbuj ponownie.';
    }
  }

  return 'Nie udało się utworzyć kolejki. Spróbuj ponownie.';
};
